"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.actions.run': 'Ejecutar Prueba',
    'botTest.actions.results': 'Ver Resultados',
};
